import { render, staticRenderFns } from "./bookerPackages.vue?vue&type=template&id=ff16a8e2&scoped=true"
import script from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
export * from "./bookerPackages.vue?vue&type=script&setup=true&lang=js"
import style0 from "./bookerPackages.vue?vue&type=style&index=0&id=ff16a8e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff16a8e2",
  null
  
)

export default component.exports